import React from 'react';
import LeftImageRightText from '../../../components/left-image-right-text';
import { graphql, useStaticQuery, Link } from 'gatsby';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';
import VedantaSustainabilityReport from '../../../../static/pdf/Vedanta_SDR_2019.pdf';
import VedantaLimitedTTR from '../../../../static/pdf/Vedanta_Limited_TTR_2019.pdf';
import AnualReport from '../../../../static/pdf/VEDL_Integrated_Annual_Report_2018_19.pdf';

const ReportingSuite = () => {
  return (
    <div className="reporting-suite">
      <h3 className="blue-2">Our Reporting Suite</h3>
      <div className="v-row">
        <div className="v-col">
          <LeftImageRightText
            image="vedanta-resources-sustanability-report.png"
            alt="vedanta resourcessustanability report"
          >
            <h6>Vedanta Resources Sustainability Report</h6>
            <p>(SR) 2018-19 </p>
            <div className="links link-anim">
              <a href={VedantaSustainabilityReport} target="_blank" className="link-download">Download Report</a>
            </div>
          </LeftImageRightText>
        </div>
        <div className="v-col">
          <LeftImageRightText image="vedanta-tax-transparency.png" alt="tax transparency report">
            <h6>Vedanta Limited Tax Transparency Report</h6>
            <p>(TTR) 2018-19 </p>
            <div className="links link-anim">
              <a href={VedantaLimitedTTR} target="_blank" className="link-download ">
                Download Report
              </a>
            </div>
          </LeftImageRightText>
        </div>
        <div className="v-col">
          <LeftImageRightText image="vedanta-integrated-report.png" alt="integrated report">
            <h6>Vedanta Limited Integrated Report (IR) and Annual Accounts</h6>
            <p>(IR) 2018-19 </p>
            <div className="links two-col-links">
              <div className="link-downlod-img link-anim">
                <a href={AnualReport} target="_blank" className="link-download">Download Report</a>
              </div>
              <div className="links link-chain-img link-anim">
                <Link to="https://www.vedantalimited.com/AR2019/" className="link-chain" target="_blank"></Link>
              </div>
            </div>
          </LeftImageRightText>
        </div>
      </div>
    </div>
  );
};

export default ReportingSuite;
